// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2tTk0","modalForm":"UpgradeEpcsModal_modalForm__1OKYG","modalFooter":"UpgradeEpcsModal_modalFooter__1Qn-z"};